import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Logo from 'ui-component/Logo';
import Box from '@mui/material/Box';

interface LoaderProps {
    size?: number;
    color?: 'primary' | 'secondary' | 'inherit';
    withLogo?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ size = 40, color = 'primary', withLogo = false }) => {
    return (
        <Stack
            direction={withLogo ? 'column' : 'row'}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            sx={{
                height: '100vh',
                width: '100vw',
                backgroundColor: 'rgba(255, 255, 255, 0.8)' // Optional semi-transparent background
            }}
        >
            {withLogo && (
                <Box
                    sx={{
                        width: '100px', // Match Logo's width
                        animation: 'pop 1.5s infinite ease-in-out',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Logo width={100} />
                </Box>
            )}
            {!withLogo && <CircularProgress size={size} color={color} />}

            <style>
                {`
                    @keyframes pop {
                        0%, 100% {
                            transform: scale(1);
                        }
                        50% {
                            transform: scale(1.2);
                        }
                    }
                `}
            </style>
        </Stack>
    );
};

export default Loader;
